import styled, { css, keyframes } from 'styled-components'

const getColorByStatusCor = (statusCor) => {
  switch (statusCor) {
    case 'Verde':
      return '#27ae60'
    case 'Vermelho':
      return '#fa3434'
    case 'Amarelo':
      return '#ffa500'
    default:
      return '#27ae60'
  }
}
const showContent = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const Wrapper = styled.div`
  padding: 16px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  position: relative;

  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

  width: calc(50% - 16px);
  min-width: 360px;

  display: flex;
  justify-content: space-between;

  transition: all ease-in-out 400ms;
  animation: ${showContent} 400ms;

  .detalhe-link {
    position: absolute;
    bottom: 16px;
    right: 16px;

    button {
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
      text-decoration: underline;
      background: transparent;
      border: none;
      cursor: pointer;
    }
  }

  @media (max-width: 800px) {
    min-width: 300px;
    width: 100%;
  }

  @media (max-width: 400px) {
    max-width: 100%;
  }
`

export const CardInfo = styled.div`
  p {
    margin-bottom: 4px;
    font-size: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    text-decoration: underline;
  }

  p.numero {
    font-size: 16px;
  }

  strong {
    font-weight: 600;
  }
`

export const Tag = styled.div`
  ${({ color }) => css`
    padding: 4px 8px;
    font-size: 13px;
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
    top: 16px;
    right: 16px;
    max-height: 24px;
    position: absolute;
    background-color: ${getColorByStatusCor(color)};
  `}
`

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`
